import React, { createContext, useContext, useState } from 'react';

export enum ResponsivePageView {
  Home = 'home',
  Map = 'map',
  Details = 'details',
}

interface OutageResponsivePageTrackerContextProps {
  page: ResponsivePageView;
  setPage: (val: ResponsivePageView) => void;
}

const OutageResponsivePageTrackerContext = createContext<
  OutageResponsivePageTrackerContextProps | undefined
>(undefined);

export const OutageResponsivePageTrackerProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [page, setPage] = useState<ResponsivePageView>(ResponsivePageView.Home);

  return (
    <OutageResponsivePageTrackerContext.Provider
      value={{
        page,
        setPage,
      }}
    >
      {children}
    </OutageResponsivePageTrackerContext.Provider>
  );
};

export const useOutageResponsivePageTracker = (): OutageResponsivePageTrackerContextProps => {
  const ctx = useContext(OutageResponsivePageTrackerContext);
  if (!ctx) {
    throw new Error(
      'useOutageResponsivePageTracker must be used within OutageResponsivePageTrackerProvider',
    );
  }
  return ctx;
};
